import Const from 'const';
import {ComboUnitInterface} from 'components/organisms/correlation-stacking/interfaces/combo-unit';
import {LineupStackCombinationsMapInterface} from 'components/organisms/correlation-stacking/interfaces/lineup-stack-combinations-map.interface';

const LineupStackCombinationsMap = {
    lineups: {},
    combinations: {},
};

class LineupCorrelationStackCombinations {
    constructor(public readonly data: LineupStackCombinationsMapInterface = LineupStackCombinationsMap) {}
    public getLineupIdsByCheckedCombinations(comboUnits: ComboUnitInterface[]): string[] {
        const {combinations} = this.data;

        const lineupIds: string[] = [];
        comboUnits.map((comboUnit) => {
            Object.keys(combinations[comboUnit.getUnitId()] || {}).map((lineupId) => lineupIds.push(lineupId));
        });

        return arrayUnique(lineupIds);
    }
}

const lineupCorrelationStackCombinations = new LineupCorrelationStackCombinations();

export default function (state = lineupCorrelationStackCombinations, action) {
    switch (action.type) {
        case Const.SET_LINEUP_CORRELATION_STACK_COMBINATIONS_MAP:
            return new LineupCorrelationStackCombinations(action.data);

        case Const.UNSET_LINEUPS:
        case Const.RESET_ALL_SETTINGS:
        case Const.FILTER_BY_SLATE:
            return new LineupCorrelationStackCombinations();

        default:
            return state;
    }
}
